import api from './api';
import { COUNTRY_OR_REGION_LIST, COUNTRY_OR_REGION_MAP } from '@pro/common/consts/country-or-region';
import createSelectDropdown from './create-select-dropdown';
import i18n from '@/natives/libs/i18n';
import useEventBus from '@/natives/libs/hooks/useEventBus';
import * as regionConfig from '@pro/common/consts/region-config';
import getRoute from '@pro/common/utils/getRoute';
import getURLByIndex from '@pro/common/utils/getURLByIndex';
import ImgLogo from '@/Common/assets/nva_image_logo.svg';

const ENABLE_DOMAIN_JUMP = Object.values(regionConfig.REGION_HREF).includes(window.location.origin);
const NEUTRAL = process.env.appmode === 'NEUTRAL';

let selectDropdown;

async function updateMainOrigin(index) {
  const createIframe = (url) => {
    const iframe = document.createElement('iframe');
    iframe.style.position = 'fixed';
    iframe.style.opacity = 0;
    iframe.style.pointerEvents = 'none';
    iframe.src = url;
    iframe.onload = () => {
      iframe.remove();
    };
    document.body.appendChild(iframe);
  };
  createIframe(`https://hik-partner.com/Common/static/update-country-or-region.html#${index}`);
  createIframe(`https://www.hik-partner.com/Common/static/update-country-or-region.html#${index}`);
}

/**
 * 初始化当前选择的国家或区域
 */
async function initSelectedCountry() {
  const route = getRoute();

  // LTS和中性默认美国
  if (NEUTRAL) {
    return 23;
  }

  // 更新大区信息的操作放在最上面
  if (route.query.country) {
    // 如果是从其他大区切换过来，则调主域名iframe将索引更新到主域名缓存
    updateMainOrigin(route.query.country);
  }
  // 俄罗斯大区单独一个 index，不需要读取localStorage 或 通过ip定位
  if (['https://hik-partnerru.com', 'https://www.hik-partnerru.com'].includes(window.location.origin)) {
    return 172;
  }
  // 印度大区单独一个 index，不需要读取localStorage 或 通过ip定位
  if (['https://iind.hik-partner.com'].includes(window.location.origin)) {
    return 106;
  }


  // 优先取url带的国家或区域索引进行初始化
  let storageIndex = route.query.country || localStorage.getItem('hik_connect_pro_country');
  storageIndex = storageIndex ? Number(storageIndex) : -1;
  storageIndex = Number.isNaN(storageIndex) ? -1 : storageIndex;
  storageIndex = COUNTRY_OR_REGION_MAP[storageIndex] ? storageIndex : -1;
  if (storageIndex > -1) {
    return storageIndex;
  }
  // 根据ip地址确定所在国家或区域
  const resp = await api.getCountryFlag().catch(() => null);
  const countryCodeString = resp?.[2]?.data?.areaInfo?.countryCode;
  if (countryCodeString) {
    const countryCodeNumber = Number(countryCodeString);
    let index = -1;
    if (Number.isNaN(countryCodeNumber)) {
      index = COUNTRY_OR_REGION_LIST().find((item) => item.countryCode === countryCodeString)?.index ?? -1;
    } else {
      index = COUNTRY_OR_REGION_MAP[countryCodeNumber] ? countryCodeNumber : -1;
    }

    if (index > -1) {
      return index;
    }
  }

  // 根据大区确定默认索引
  const index
    = {
      'https://ius.hik-partner.com': 24,
      'https://isa.hik-partner.com': 54,
      'https://isgp.hik-partner.com': 187,
      'https://ieu.hik-partner.com': 22,
      'https://www.hik-partner.com': 22,
      'https://iind.hik-partner.com': 106,
      'https://www.guardingmaster.com': 23,
      'https://www.ltsplatinumpartner.com': 23,
      'https://ius.ltsplatinumpartner.com': 24,
      'https://isa.ltsplatinumpartner.com': 54,
      'https://isgp.ltsplatinumpartner.com': 187,
      'https://ieu.ltsplatinumpartner.com': 22,
      'https://iind.ltsplatinumpartner.com': 106
    }[window.location.origin] ?? 187;

  return index;
}

let isUrlJumping = false;
function handleChange(index) {
  // 优先保存国家或区域索引到`localstorage`
  localStorage.setItem('hik_connect_pro_country', index);
  if (ENABLE_DOMAIN_JUMP) {
    const url = getURLByIndex(index);
    if (url && window.location.origin !== url && window.location.origin.replace('www.', '') !== url && !isUrlJumping) {
      isUrlJumping = true;
      // 增加v标志，避免在跨大区跳转时，访问到目标大区的缓存页面
      const resultUrl = `${url}?v=${Date.now()}&type=jump&country=${index}`;
      window.location.href = resultUrl;
    }
  }
  if (!isUrlJumping) {
    doIndiaConfig(index); // 处理印度隐藏 Channel Partner Program
    doKeyFeaturesConfig(index); // 处理key-features 特殊国家文案
    const countryOrRegionChange = useEventBus('country-or-region-change');
    countryOrRegionChange.emit(index);
  }
}
function doIndiaConfig(index) {
  const channelDom = document.querySelector('.channel-components-wrapper');
  if (channelDom) {
    channelDom.style.display = index === 106 ? 'none' : 'block';
  }
}
function doKeyFeaturesConfig(index) {
  const flag = [22, 109].includes(index);
  const keyDom0 = document.querySelector('#key-features-country-change-0');
  if (keyDom0) {
    keyDom0.innerHTML = i18n.t(flag ? 'reduce_installation_time_label_2_GB' : 'reduce_installation_time_label_2');
    keyDom0.title = i18n.t(flag ? 'reduce_installation_time_label_2_GB' : 'reduce_installation_time_label_2');
  }

  const keyDom1 = document.querySelector('#key-features-country-change-1');
  if (keyDom1) {
    keyDom1.innerHTML = i18n.t(
      flag ? 'remote_configuration_maintain_content_1_GB' : 'remote_configuration_maintain_content_1'
    );
    keyDom1.title = i18n.t(
      flag ? 'remote_configuration_maintain_content_1_GB' : 'remote_configuration_maintain_content_1'
    );
  }

  const keyDom2 = document.querySelector('#key-features-country-change-2');
  if (keyDom2) {
    keyDom2.innerHTML = i18n.t(flag ? 'integration_with_arc_content_1_GB' : 'integration_with_arc_content_1');
    keyDom2.title = i18n.t(flag ? 'integration_with_arc_content_1_GB' : 'integration_with_arc_content_1');
  }
}

/**
 * mounted
 */
(async function () {
  (document.querySelector('.header-logo') || {}).src = ImgLogo;
  const container = document.getElementById('select-area');
  if (COUNTRY_OR_REGION_LIST().length === 1) {
    container.style.display = 'none';
    handleChange(COUNTRY_OR_REGION_LIST()[0].index);
    return;
  }
  const options = COUNTRY_OR_REGION_LIST().map((item) => ({
    ...item,
    label: i18n.t(item.label)
  }));
  selectDropdown = createSelectDropdown(container, options);
  const index = await initSelectedCountry();
  selectDropdown.on('select', handleChange);
  selectDropdown.select(index);
})();
